import { Observable } from "rxjs";
import { DependencyList, useEffect } from "react";

export const useObserverCallback = <T>(
  observer: Observable<T>,
  callback: (props: T) => void,
  deps: DependencyList = []
) => {
  useEffect(() => {
    const subscription = observer.subscribe(callback);
    return () => {
      subscription?.unsubscribe();
    };
  }, deps);
};
